import styled, { css } from 'styled-components';

import { ReactComponent as FollowUpsIcon } from '../../../../../assets/icons/follow-ups-icon.svg';
import { ReactComponent as PaymentPendingIcon } from '../../../../../assets/icons/payment-pending-icon.svg';
import { ReactComponent as ContractsManagerIcon } from '../../../../../assets/icons/contracts-icon.svg';
import {
  ReactComponent as LeadsContactedIcon,
} from '../../../../../assets/icons/menuIcons/feedMenuIcons/client-status.svg';

import colors from '../../../../../styles/colors';

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  border: 1.5px solid ${colors.shades.secondary7};
`;

const TabHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${colors.shades.gamma5};
`;

const PageContent = styled.div`
  height: 550px;
  display: flex;
  flex-direction: column;
  margin: 30px 0 40px 20px;
`;

const iconStyles = css`
  height: 20px;
  width: 20px;
  margin-right: 2px;
  fill: ${colors.shades.secondary7};
`;

const createStyledIcon = (IconComponent) => styled(IconComponent)`
  ${iconStyles};
`;

const StyledFollowUpsIcon = createStyledIcon(FollowUpsIcon);
const StyledPaymentPendingIcon = createStyledIcon(PaymentPendingIcon);
const StyledContractsManagerIcon = createStyledIcon(ContractsManagerIcon);
const StyledLeadsContactedIcon = createStyledIcon(LeadsContactedIcon);

export {
  HeaderContainer,
  TabHeaderRow,
  PageContent,
  StyledFollowUpsIcon,
  StyledPaymentPendingIcon,
  StyledContractsManagerIcon,
  StyledLeadsContactedIcon,
};
